export default {
    buttons: {
        add_location: 'Dodaj lokaciju',
    },
    fields: {
        name: {
            label: 'Naziv usluge',
            placeholder: 'Unesite naziv usluge',
        },
        company: {
            label: 'Kompanija (neobavezno)',
            placeholder: 'Odaberite',
        },
        location: {
            label: 'Lokacija usluge',
            placeholder: 'Odaberite',
        },
        description: {
            label: 'Opis',
            placeholder: 'Opišite vašu uslugu...',
        },

        appointment_length: {
            label: 'Trajanje termina',
            placeholder: 'Odaberite',
        },
        price: {
            label: 'Cijena',
            placeholder: 'Odaberite',
        },
        currency: {
            label: 'Valuta',
            placeholder: 'EUR/RDS',
        },
        category: {
            label: 'Kategorija',
            placeholder: 'Odaberite',
        },
        subcategory: {
            label: 'Potkategorija',
            placeholder: 'Odaberite',
        },
        default_calendar_event_status: {
            label: 'Da li želite da rezervacije za ovu uslugu budu automatski prihvaćene?',
        },
        public_reservation: {
            label: 'Blokiraj javne rezervacije?',
        },
        reservation_in_advance: {
            label: 'Dozvoli da se rezerviše unaprijed',
            placeholder: 'Odaberite',
            tooltip:
                'Koliko unaprijed dozvoljavate da klijenti rezervišu termin. Npr. 60min, klijent neće moći da rezerviše termin koji počinje za manje od sat vremena.',
        },
        cancellation_in_advance: {
            label: 'Dozvoli da se otkaže unaprijed',
            placeholder: 'Odaberite',
            tooltip:
                'Koliko unaprijed dozvoljavate da klijenti otkažu termin. Npr. 60min, klijent neće moći da otkaže termin koji počinje za manje od sat vremena.',
        },
        rescheduling_in_advance: {
            label: 'Dozvoli da se odloži unaprijed',
            placeholder: 'Odaberite',
            tooltip:
                'Koliko unaprijed dozvoljavate da klijenti odlože termin. Npr. 60min, klijent neće moći da odloži termin koji počinje za manje od sat vremena.',
        },
        pause: {
            label: 'Dužina pauze (Min)',
            placeholder: 'Unesite',
            tooltip:
                'Unesite željeno trajanje pauze ili perioda neaktivnosti (u minutama). Vrijeme u vašem kalendaru biće podijeljeno na intervale u trajanju od toliko minuta. Minimalno trajanje je 15 minuta, a maksimalno 180 minuta.',
        },
        reservation_type: {
            label: 'Tip rezervacije',
            placeholder: 'Odaberite',
            tooltip:
                'Odobravanje - vi ručno prihvatate rezervacije; Automatski - rezervacije se same prihvataju, Blokiranje - samo vi možete sebi narpaviti rezervaciju, Regos - tehnički pregledi',
        },
    },
    reservation_type: {
        request_approval: 'Odobravanje rezervacija',
        accepted_by_default: 'Automatski prihvaćene rezervacije',
        block_public_reservations: 'Blokiranje javnih rezervacija',
        external_system_regos: 'Regos - eksterni sistem',
        request_service: 'Zahtjev rezervacija',
    },
    header: 'Unesite kategoriju',
    table: {
        title: 'Naziv',
        price: 'Cijena',
        length: 'Trajanje',
        description: 'Opis',
        actions: 'Akcije',
    },
    errors: {
        location: {
            company_has_no_locations: 'Ova kompanija ima 0 lokacija',
        },
        category: {
            warning: 'Da bi vaš oglas bio vidljiv morate da dodate bar jednu kategoriju!',
        },
    },
}
